/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {
    PieceOriginalImagesBody_piece$data
} from "ui/feature/piece-original-images/__generated__/PieceOriginalImagesBody_piece.graphql";
import styles from "./PieceOriginalImagesBody.module.scss";
import PieceOriginalImage from "ui/feature/piece-original-images/PieceOriginalImage";

interface Props {
    piece: PieceOriginalImagesBody_piece$data
}

const PieceOriginalImagesBody: React.FC<Props> = ({piece}) => {
    return (
        <div className={styles.imagesContainer}>
            {piece.sheets.map((sheet) => <PieceOriginalImage key={sheet.id} sheet={sheet}/>)}
        </div>
    )
}

export default createFragmentContainer(PieceOriginalImagesBody, {
    piece: graphql`
    fragment PieceOriginalImagesBody_piece on MusicPiece {
        sheets {
            id
            download_url
            ...PieceOriginalImage_sheet
        }
    }
    `
})